import { useTranslation } from 'react-i18next';
import buttonColours, { ButtonColour } from '../helpers/buttonColours';

export interface ButtonColourOptions {
  value: string;
  label: string;
  metadata: string;
}

const useButtonColours = () => {
  const { t } = useTranslation();

  const options: ButtonColourOptions[] = buttonColours.map((buttonColour: ButtonColour) => ({
    value: buttonColour.id.toString(),
    label: t(`buttonColours.${buttonColour.key}`, buttonColour.name),
    metadata: buttonColour.colour,
  }));

  options.unshift({
    value: '',
    label: t('common.none'),
    metadata: '#ffffff',
  });

  return options;
};

export default useButtonColours;
